export default class DefaultDict {
  constructor(defaultInit, args) {
    return new Proxy({}, {
      get: (dict, key) => {
        if (!(key in dict)) {
          dict[key] = typeof defaultInit === 'function' ?
            // eslint-disable-next-line new-cap
            new defaultInit(args).valueOf() : defaultInit;
        }

        return dict[key];
      },
    });
  }
}
